import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getSpotsFromFilters, getAllSpotsFromSelectedFilter, anyFilterSet } from '../../utils';
import { processFilter } from '../../actions/filters';


class FilterSpotsFooter extends Component {

  renderFooterWithoutAvailableSpots(availableFilteredSpots, allSpotsForFilter) {
    return (
      <div className="map-page-content-footer">
        <hr />
        <a className="btn btn-primary btn-block btn-lg" onClick={() => {this.props.processFilter(availableFilteredSpots, allSpotsForFilter);}}>
          {`Show ${allSpotsForFilter.length} matching spots`}
        </a>

        <p className="text-center color-danger">
          <em>
            There are no available matching spots!
          </em>
        </p>

      </div>
    );
  }

  renderFooterWithAvailableSpots(availableFilteredSpots, allSpotsForFilter) {
    const availableSpotsLength = availableFilteredSpots.length;
    const allSpotsLength = allSpotsForFilter.length;
    return (
      <div className="map-page-content-footer">
        <hr />
        <a className="btn btn-primary btn-block btn-lg" onClick={() => {this.props.processFilter(availableFilteredSpots, allSpotsForFilter);}}>
          {`Show ${availableSpotsLength} available ${availableSpotsLength === 1 ? 'spot' : 'spots'}`}
        </a>

        <p className="text-center">
          <img src="assets/images/sprite-icons/marker-pin-filtered.png" srcSet="assets/images/sprite-icons/marker-pin-filtered.png 1x, assets/images/sprite-icons/marker-pin-filtered@2x.png 2x" alt="" />&nbsp;
          {allSpotsLength} matching {allSpotsLength === 1 ? 'spot' : 'spots'} in total
        </p>

      </div>
    );
  }

  render() {
    const {availableFilteredSpots, allSpotsForFilter} = this.props;

    if(availableFilteredSpots.length) {
      return this.renderFooterWithAvailableSpots(availableFilteredSpots, allSpotsForFilter);
    } else {
      return this.renderFooterWithoutAvailableSpots(availableFilteredSpots, allSpotsForFilter);
    }
  }
}

const mapStateToProps = (state) => {
  return {
    availableFilteredSpots: getSpotsFromFilters(),
    allSpotsForFilter: getAllSpotsFromSelectedFilter()
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({processFilter}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterSpotsFooter);



// WEBPACK FOOTER //
// ./src/containers/Search/FilterSpotsFooter.js